import type { CheckoutSimple, CustomerSimple, WovarCheckout } from "@commercekit/api";
import type { PropsWithChildren } from "react";
import { CartProvider } from "~/lib/hooks/useCart";
import { CheckoutCtxProvider, CheckoutSimpleCtxProvider } from "~/lib/hooks/useCheckout";
import { CustomerSimpleCtxProvider } from "~/lib/hooks/useCustomer";

export const CommercekitCtx = ({
  children,
  customer,
  checkoutSimple,
  checkout,
}: PropsWithChildren<{
  checkoutSimple: CheckoutSimple | null;
  checkout: WovarCheckout | null;
  customer: CustomerSimple | null;
}>) => (
  <CheckoutCtxProvider checkout={checkout}>
    <CheckoutSimpleCtxProvider checkoutSimple={checkoutSimple}>
      <CustomerSimpleCtxProvider customer={customer}>
        <CartProvider>{children}</CartProvider>
      </CustomerSimpleCtxProvider>
    </CheckoutSimpleCtxProvider>
  </CheckoutCtxProvider>
);
